import { IVehicleFactory } from '../../entities/vehicle/Vehicle'
import { parseDateTime } from '../../utils/parse-date'

export interface IVehicleResponse {
  'vehicle_id':                 string  // '5b9cfd37-d79b-4db1-99b4-368ad80fe80c'
  'driver_name':                string  // elad kantor
  'eta': {
    'actual_eta':               string  // '04/05/2022 13:50'
  }
  'tracking': {
    'geolocation':              string | null // "34.09239 44.8372"
  }
  'show_vehicle_notification':  boolean // true
  'arrival_in':                 number  // 420
  'vendor_store_info': {
    'lat':                      string // "31.9901794"
    'lng':                      string // "34.7646897"
  }
}

export const transformVehicle = (vehicle: IVehicleResponse) : IVehicleFactory => {

  return {
    id: vehicle.vehicle_id,
    arrivalDuration: vehicle.arrival_in * 60,
    arrivesAt: parseDateTime(vehicle.eta.actual_eta, 3), // (GMT+03:00) Иерусалим
    driverName: vehicle.driver_name,

    geolocation: vehicle.tracking.geolocation ? {
      lat: Number(vehicle.tracking.geolocation.split(' ')[0]),
      lng: Number(vehicle.tracking.geolocation.split(' ')[1]),
    } : undefined,
    vendorGeolocation: {
      lat: Number(vehicle.vendor_store_info.lat),
      lng: Number(vehicle.vendor_store_info.lng),
    },
    shouldShow: vehicle.show_vehicle_notification,
  }
}
